<template>
  <div class="md my-3 p-3">
    <span v-html="post"></span>
  </div>
</template>

<script>
  import MarkdownIt from 'markdown-it'

  function display_post() {
    var md = new MarkdownIt()
    fetch('../privacy.md')
      .then(response => response.text())
      .then(text => {
        this.post = md.render(text);
      })
  }

  export default {
    data() {
      return {
        post: 'Loading...',
      }
    },
    created () {
      document.title = "Privacy Policy"
    },
    updated: display_post,
    mounted: display_post  // TODO updating does not seem to work
  }
</script>

<style scoped>
  span >>> p, span >>> li, span >>> em {
    font-family: "Roboto", sans-serif;
    color: var(--text-primary);
  }

  span >>> h1, span >>> h2, span >>> h3,
  span >>> h4, span >>> h5, span >>> h6 {
    font-family: "Inter", sans-serif;
    font-weight: 600;
    color: var(--text-primary);
  }

  span >>> pre {
    background-color: var(--bg-surface-raised);
    border: 1px solid var(--border-default);
    border-radius: var(--radius-sm);
    padding: 12px 16px;
    color: var(--text-primary);
  }

  span >>> a {
    color: var(--text-link);
  }
</style>